import React from 'react';
import cn from 'classnames';
import styles from './styles.module.css';
const Title = ({ small, medium, large, white, black, background, padding, text, bold, bolder, bottomLine, topLine }) => {
  return (
    <p
      className={cn(
        styles.main,
        small && styles.small,
        medium && styles.medium,
        large && styles.large,
        bold && styles.bold,
        bolder && styles.bolder,
        bottomLine && styles.bottomLine,
        topLine && styles.topLine,
        white && styles.white,
        black && styles.black,
        padding && styles.padding,
        background && styles.background
      )}
    >
      {text || 'Title'}
    </p>
  );
};
export default Title;
